import { render, staticRenderFns } from "./PlatformConfiguration.vue?vue&type=template&id=2d81b9d3&scoped=true"
import script from "./PlatformConfiguration.vue?vue&type=script&lang=js"
export * from "./PlatformConfiguration.vue?vue&type=script&lang=js"
import style0 from "./PlatformConfiguration.vue?vue&type=style&index=0&id=2d81b9d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d81b9d3",
  null
  
)

export default component.exports